import { render, staticRenderFns } from "./CampAgents.vue?vue&type=template&id=22914fd2&scoped=true&"
import script from "./CampAgents.vue?vue&type=script&lang=js&"
export * from "./CampAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22914fd2",
  null
  
)

export default component.exports